// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddAgeСategorieModal_fieldSet__zUC9O","flex":"AddAgeСategorieModal_flex__5poim"};